module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-smiley-svgrepo-com.fe94bcae.svg";